import useChatList from "./useChatList";
import styles from "../aiOrderList.module.scss";
import ChatAudio from "../ChatAudio";

const ChatList = () => {
  const {
    orderBasicData,
    isLoading,
    isFetching,
    aiordersState,
    activeAudioId,
    handleAudioPlay,
  } = useChatList();

  if (isLoading || isFetching) {
    return <p>Loading chat...</p>;
  }

  if (!orderBasicData?.data?.length) {
    return (
      <div>
        <p>No chat history found.</p>
      </div>
    );
  }

  return (
    <div className={styles["chat-container"]}>
      {orderBasicData?.data.map((msg, index) => {
        const roleLabel =
          msg.role === "user" ? aiordersState?.userName || "User" : "Bot";

        return (
          <div
            key={index}
            className={`${styles["chat-message"]} ${
              msg.role === "user" ? styles["chat-user"] : styles["chat-model"]
            }`}
          >
            <small className={styles["chat-role"]}>{roleLabel}</small>
            <p>{msg.content}</p>
            {msg?.audio_url && (
              <ChatAudio
                key={index}
                id={index} // unique for each audio
                url={msg.audio_url}
                activeAudioId={activeAudioId}
                onAudioPlay={handleAudioPlay}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ChatList;
